type predicate<T> = (arg: T) => boolean;

interface Array<T> {
    firstOrDefault<T>(predicate?: predicate<T>): T;
    any(): T;
    groupBy<K extends keyof any>(keyFn: (item: T) => K): Record<K, T[]>;
    hasSameValues(arr: T[]): boolean
}

Array.prototype.firstOrDefault = function (predicate?: Function) {
    return this.reduce((accumulator, currentValue) => {

        if (!accumulator && (!predicate || predicate(currentValue)))
            accumulator = currentValue;

        return accumulator;
    }, null);
};

Array.prototype.any = function () {
    return this.some(item => item);
}

Array.prototype.groupBy = function <T, K extends keyof any>(
    this: T[],
    keyFn: (item: T) => K
  ): Record<K, T[]> {
    return this.reduce((acc, item) => {
      const key = keyFn(item);
      (acc[key] = acc[key] || []).push(item);
      return acc;
    }, {} as Record<K, T[]>);
};

Array.prototype.hasSameValues = function<T>(this: T[], arr: T[]) {
    if(this.length !== arr.length) {
        return false;
    }

    const sorted1 = this.sort();
    const sorted2 = arr.sort();

    return sorted1.every((x, i) => x === sorted2[i]);
}